import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../../Reducers/actions'
import { useNavigate } from 'react-router-dom';
import { Tooltip, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Info } from 'lucide-react';

import { dataService } from "../../../../Services/data/data.service";


function ProjectButton(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const SaveAndRedirect = () => {

        navigate(`/modifyproject/${props.data.qrCode}`);

    }

    return (
        <div>
            <Tooltip title={t('results.projectInformation')} placement="top" arrow>
                <IconButton style={{ borderRadius: 0 }} onClick={SaveAndRedirect}>
                    <Info />
                </IconButton>
            </Tooltip>

        </div>
    )
}

const mapStateToProps = state => ({
    projects: state.projects,
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
    mapStateToProps,
    mapDispatchToProps
))(ProjectButton);